// The folder a file picker last showed, per share, so the next picker on the
// same share (in any part of the site) opens there. Kept per browser in
// localStorage; the server falls back to the nearest existing parent when the
// folder has since been removed.

export type ShareId = 'source' | 'output';

const key = (share: ShareId) => `filepicker:last-dir:${share}`;

export function getLastDir(share: ShareId): string {
  try { return localStorage.getItem(key(share)) || '/'; } catch { return '/'; }
}

export function setLastDir(share: ShareId, path: string): void {
  try { localStorage.setItem(key(share), path); } catch { /* storage unavailable: just don't remember */ }
}
